import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { encodeQueryValue } from "./queryString";
import { catalogLegacyQuery, catalogListLimit, localCatalogAction } from "./catalogRequest";
import { normalizeProductMutationValues } from "./productContract";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  const normalizedValues = normalizeProductMutationValues(values);
  for (let value in normalizedValues) {
    if (["gender"].includes(value) && normalizedValues[value] && typeof normalizedValues[value] === "object") {
      formData.append(value, normalizedValues[value].value);
    } else {
      formData.append(value, normalizedValues[value]);
    }
  }
  const action = "afterlogin/products/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  const normalizedValues = normalizeProductMutationValues(values);
  for (let value in normalizedValues) {
    formData.append(value, normalizedValues[value] === null ? "" : normalizedValues[value]);
  }
  const action = "afterlogin/products/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const dropdown = values && values.dropdown ? values.dropdown : "";
  const result = values && values.result ? values.result : "";
  const q = typeof (values && values.q) === "string" ? values.q.trim() : catalogLegacyQuery(values, "q") || "";
  const encodedQ = encodeQueryValue(q);
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    let sortSubArray = [];
    Object.keys(sort).map(function (key, index) {
      if (Object.keys(sort[key]).length > 0) {
        Object.keys(sort[key]).map(function (subkey, subindex) {
          sortSubArray[subindex] = `sort[${key}.${subkey}]=${sort[key][subkey]}`;
        });
      }
      if (key != "supplier") {
        sortArray[index] = `sort[${key}]=${sort[key]}`;
      }
    });
    if (sortSubArray.length > 0) {
      let jsubsort = sortSubArray.join("&");
      sortstring = jsubsort;
    }
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (Object.prototype.hasOwnProperty.call(values, "pagination")) {
      pagination = values.pagination;
    }
  }
  const query = [sortstring, q ? `q=${encodedQ}` : ""].filter(Boolean).join("&");
  const action = localCatalogAction("afterlogin/products/view", values, query);
  let productdata;
  if (dropdown) {
    productdata = {
      auth_key: auth_key,
      action: action,
      salon_id: auth.user.salon_id,
      pagination: false, //true or false
      id: "",
      result: result, //business_name,owner_name
    };
  } else {
    productdata = {
      auth_key: auth_key,
      action: action,
      salon_id: auth.user.salon_id,
      pagination: pagination, //true or false
      id: values && values.id ? values.id : "",
      result: result, //business_name,owner_name
    };
  }

  const limit = catalogListLimit(values);
  if (limit) productdata.limit = limit;
  if (q) {
    productdata.apicall = "suggetion";
    productdata.q = q;
  }

  const data = productdata;
  data.action = action;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/products/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader(), ...(values.archive === true ? { deleteConfirmation: false } : {}) });
};

const suggetionlist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  let q = typeof (values && values.q) === "string" ? values.q : catalogLegacyQuery(values, "q") || "";
  const encodedQ = encodeQueryValue(q);
  const action = localCatalogAction("afterlogin/products/view", values, `q=${encodedQ}`);
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    apicall: "suggetion",
    q,
  };
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  data.action = action;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const productimport = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/products/productimport`;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  // formData.append("excelfile", values.excelfile);
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};
const productexport = (values) => {
  const action = `afterlogin/products/productexport`;
  const payload = {};
  if (values && values.id !== undefined && values.id !== null && values.id !== "") {
    payload.id = values.id;
  }
  if (values && values.sort) payload.sort = values.sort;
  return axios.post(API_URL + action, payload, {
    headers: authHeader(),
    responseType: "blob",
  });
};

const stockAdjust = (values = {}) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = "afterlogin/products/stock/adjust";
  const data = {
    product_id: values.product_id,
    quantity_change: values.quantity_change,
    reason: values.reason,
    auth_key: auth_key,
    action: action,
  };
  if (values.note) data.note = values.note;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const stockReasons = () => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = "afterlogin/products/stock/reasons";
  return axios.post(API_URL + action, { auth_key: auth_key, action: action }, { headers: authHeader() });
};

const stockMovements = (values = {}) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = "afterlogin/products/stock/movements";
  const data = { auth_key: auth_key, action: action };
  if (values.product_id !== undefined && values.product_id !== null && values.product_id !== "") {
    data.product_id = values.product_id;
  }
  if (values.limit !== undefined && values.limit !== null && values.limit !== "") {
    data.limit = values.limit;
  }
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

// The stocktake actions are declared as full literal routes so the
// SOF-26 endpoint-parity guard can match each call to its live Flask route;
// Flask registers `start`, `view`, `count` and `complete` separately.
const stocktakeRequest = (action, values = {}) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const data = { ...values, auth_key: auth_key, action: action };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const stocktakeStart = () => stocktakeRequest("afterlogin/products/stocktakes/start");

const stocktakeView = (values = {}) => {
  const data = {};
  if (values.stocktake_id !== undefined && values.stocktake_id !== null && values.stocktake_id !== "") {
    data.stocktake_id = values.stocktake_id;
  }
  return stocktakeRequest("afterlogin/products/stocktakes/view", data);
};

const stocktakeCount = (values = {}) => stocktakeRequest("afterlogin/products/stocktakes/count", {
  stocktake_id: values.stocktake_id,
  counts: Array.isArray(values.counts) ? values.counts : [],
});

const stocktakeComplete = (values = {}) => stocktakeRequest("afterlogin/products/stocktakes/complete", {
  stocktake_id: values.stocktake_id,
  ...(values.resolve_stale ? { resolve_stale: true } : {}),
});

const stocktakeReport = (values = {}) => stocktakeRequest("afterlogin/products/stocktakes/report", {
  stock_as_of_date: values.stock_as_of_date,
});
const stocktakeExport = (values = {}) => axios.post(API_URL + "afterlogin/products/stocktakes/export", {
  ...(values.stocktake_id ? { stocktake_id: values.stocktake_id } : { stock_as_of_date: values.stock_as_of_date }),
}, { headers: authHeader(), responseType: "text" });

const productApiController = {
  create,
  update,
  view,
  deleted,
  suggetionlist,
  productimport,
  productexport,
  stockAdjust,
  stockReasons,
  stockMovements,
  stocktakeStart,
  stocktakeView,
  stocktakeCount,
  stocktakeComplete,
  stocktakeReport,
  stocktakeExport,
};
export default productApiController;
